import { render, staticRenderFns } from "./wineCabinetList.vue?vue&type=template&id=10b9ad1f&scoped=true&"
import script from "./wineCabinetList.vue?vue&type=script&lang=js&"
export * from "./wineCabinetList.vue?vue&type=script&lang=js&"
import style0 from "./wineCabinetList.vue?vue&type=style&index=0&id=10b9ad1f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b9ad1f",
  null
  
)

export default component.exports